import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import VehicleStereoTypeScreen from "../../../container/Vehicles/VehicleStereoTypeScreen";
import CreateVehicleStereoType from "../../../container/Vehicles/VehicleStereoTypeScreen/CreateVehicleStereoType";

const VehicleStereoTypeRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_STEREOTYPE.HOME}
          element={<VehicleStereoTypeScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.VEHICLE_STEREOTYPE.CREATE}
          element={<CreateVehicleStereoType />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.VEHICLE_STEREOTYPE.EDIT}
          element={<CreateVehicleStereoType isEdit={true} />}
        />
      )}
    </>
  );
};

export default VehicleStereoTypeRoutes;
